export const SuccessIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="67"
      height="67"
      viewBox="0 0 67 67"
    >
      <path
        id="check_circle_24dp_5F6368_FILL0_wght400_GRAD0_opsz24"
        d="M108.81-831.09l23.617-23.618-4.69-4.69L108.81-840.47l-9.548-9.547-4.69,4.69ZM113.5-813a32.621,32.621,0,0,1-13.065-2.638A33.829,33.829,0,0,1,89.8-822.8a33.83,33.83,0,0,1-7.161-10.636A32.621,32.621,0,0,1,80-846.5a32.621,32.621,0,0,1,2.638-13.065A33.829,33.829,0,0,1,89.8-870.2a33.828,33.828,0,0,1,10.636-7.161A32.62,32.62,0,0,1,113.5-880a32.62,32.62,0,0,1,13.065,2.638A33.828,33.828,0,0,1,137.2-870.2a33.829,33.829,0,0,1,7.161,10.636A32.621,32.621,0,0,1,147-846.5a32.621,32.621,0,0,1-2.638,13.065A33.83,33.83,0,0,1,137.2-822.8a33.829,33.829,0,0,1-10.636,7.161A32.621,32.621,0,0,1,113.5-813Zm0-6.7a25.865,25.865,0,0,0,19.011-7.789A25.865,25.865,0,0,0,140.3-846.5a25.865,25.865,0,0,0-7.789-19.011A25.865,25.865,0,0,0,113.5-873.3a25.865,25.865,0,0,0-19.011,7.789A25.865,25.865,0,0,0,86.7-846.5a25.865,25.865,0,0,0,7.789,19.011A25.865,25.865,0,0,0,113.5-819.7ZM113.5-846.5Z"
        transform="translate(-80 880)"
        fill="#099"
      />
    </svg>
  );
};
